import { SchoolUserRole } from '@novaheal/types';
import { CellProps } from '../types/Cell';
import { SelectCell, SelectCellProps } from './SelectCell';
import { DefaultCell } from './DefaultCell';

export const RoleCell = (props: CellProps): JSX.Element | null => {
  const { value, label, ...rest } = props as SelectCellProps;

  if (value === SchoolUserRole.ADMIN) {
    return DefaultCell({ ...rest, label: 'Admin' });
  }
  if (
    value === SchoolUserRole.TEACHER ||
    value === SchoolUserRole.STUDENT ||
    value === SchoolUserRole.GUIDE
  ) {
    return SelectCell({ ...rest, label, value });
  }
  // fallback: show value or label as string
  return DefaultCell({ ...rest, label: typeof label === 'string' ? label : String(value) });
};
